$(document).ready(function() {
        var $highlight = $('.highlight');

        // Mover el highlight al entrar en un elemento
          $('div.main-menu ul li').on('mouseenter', function() {
            var $this = $(this),
                // Obtener la posición y el ancho del elemento actual
                leftPos = $this.position().left,
                newWidth = $this.outerWidth();

            // Mover el highlight usando translateX y ajustar el ancho
            $highlight.css({
                'opacity': '1',
                'transform': 'translateX(' + leftPos + 'px)',
                'width': newWidth + 'px'
            });
          });

          // Al hacer clic, también mantener el highlight en el elemento activo
          $('div.main-menu ul li a').on('click', function(e) {
            //e.preventDefault();
            //$('div.main-menu ul li').removeClass('active');
            //$(this).parent('li').addClass('active');

            var $this = $(this).parent(),
                leftPos = $this.position().left,
                newWidth = $this.outerWidth();

            // Mantener el highlight en el elemento activo
            $highlight.css({
              'transform': 'translateX(' + leftPos + 'px)',
              'width': newWidth + 'px'
            });
          });

        $('div.main-menu').on('mouseleave', function(e) {
            $highlight.css({
              'opacity': '0' // Ocultar el highlight cuando el mouse salga de nav
            });
        });
    });
      // Exemple de script de page, add it to $additional_bottom_scripts = []; on the  page
